module.exports = __webpack_public_path__ + "static/media/user.a5dab48f.png";